"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CredentialTypeEnum;
(function (CredentialTypeEnum) {
    CredentialTypeEnum["ABV"] = "ABV - Accredited in Business Valuations Credential";
    CredentialTypeEnum["CVFI"] = "CVFI - Certified in Valuation of Financial Ins";
    CredentialTypeEnum["CFF"] = "CFF - Certified in Financial Forensics Credential";
    CredentialTypeEnum["CITP"] = "CITP - Certified Information Technology Profession";
    CredentialTypeEnum["PFS"] = "PFS - Personal Financial Specialist Credential";
    CredentialTypeEnum["CGMA"] = "CGMA - Chartered Global Management Accountant Designation";
    CredentialTypeEnum["MIP"] = "Members in Practice";
    CredentialTypeEnum["FCMA"] = "FCMA";
    CredentialTypeEnum["ACMA"] = "ACMA";
})(CredentialTypeEnum = exports.CredentialTypeEnum || (exports.CredentialTypeEnum = {}));
var CredentialTooltipEnum;
(function (CredentialTooltipEnum) {
    CredentialTooltipEnum["ABV"] = "Accredited in Business Valuation (ABV\u00AE) credential";
    CredentialTooltipEnum["CVFI"] = "Certified Information Technology Professional (CITP) credential";
    CredentialTooltipEnum["CFF"] = "Certified in Financial Forensics (CFF) credential";
    CredentialTooltipEnum["CITP"] = "Certified in the Valuation of Financial Instruments (CVFI\u00AE) credential";
    CredentialTooltipEnum["PFS"] = "Personal Financial Specialist (PFS\u2122) credential ";
    CredentialTooltipEnum["CGMA"] = "Chartered Global Management Accountant\u00AE (CGMA) designation";
    CredentialTooltipEnum["MIP"] = "CIMA Member in Practice (MiP)";
    CredentialTooltipEnum["FCMA"] = "Fellow Chartered Management Accountant (FCMA)";
    CredentialTooltipEnum["ACMA"] = "Associate Chartered Management Accountant (ACMA)";
})(CredentialTooltipEnum = exports.CredentialTooltipEnum || (exports.CredentialTooltipEnum = {}));
var DirectoryKeys;
(function (DirectoryKeys) {
    DirectoryKeys["CITP"] = "CITP";
    DirectoryKeys["PFS"] = "PFS";
    DirectoryKeys["CFF"] = "CFF";
    DirectoryKeys["CVFI"] = "CVFI";
    DirectoryKeys["ABV"] = "ABV";
    DirectoryKeys["CGMA"] = "CGMA";
    DirectoryKeys["MIP"] = "MIP";
    DirectoryKeys["FCMA"] = "FCMA";
    DirectoryKeys["ACMA"] = "ACMA";
})(DirectoryKeys = exports.DirectoryKeys || (exports.DirectoryKeys = {}));
var Credentials;
(function (Credentials) {
    Credentials["MIP"] = "Members in Practice";
    Credentials["MIP_SINGULAR"] = "Member in Practice";
})(Credentials = exports.Credentials || (exports.Credentials = {}));
exports.CredentialType = [
    {
        key: 1,
        text: CredentialTypeEnum.ABV,
        value: 'ABV',
    },
    {
        key: 2,
        text: CredentialTypeEnum.CVFI,
        value: 'CVFI',
    },
    {
        key: 3,
        text: CredentialTypeEnum.CFF,
        value: 'CFF',
    },
    {
        key: 4,
        text: CredentialTypeEnum.CITP,
        value: 'CITP',
    },
    {
        key: 5,
        text: CredentialTypeEnum.PFS,
        value: 'PFS',
    },
    {
        key: 6,
        text: CredentialTypeEnum.CGMA,
        value: 'CGMA',
    },
    {
        key: 7,
        text: CredentialTypeEnum.MIP,
        value: 'MIP',
    },
    {
        key: 8,
        text: CredentialTypeEnum.FCMA,
        value: CredentialTypeEnum.FCMA,
    },
    {
        key: 9,
        text: CredentialTypeEnum.ACMA,
        value: CredentialTypeEnum.ACMA,
    },
];
exports.DirectoryCredentialType = [
    {
        key: 1,
        text: CredentialTypeEnum.ABV,
        value: 'ABV',
    },
    {
        key: 2,
        text: CredentialTypeEnum.CVFI,
        value: 'CVFI',
    },
    {
        key: 3,
        text: CredentialTypeEnum.CFF,
        value: 'CFF',
    },
    {
        key: 4,
        text: CredentialTypeEnum.CITP,
        value: 'CITP',
    },
    {
        key: 5,
        text: CredentialTypeEnum.PFS,
        value: 'PFS',
    },
    {
        key: 6,
        text: CredentialTypeEnum.CGMA,
        value: 'CGMA',
    },
    {
        key: 7,
        text: 'MiP - Members in Practice',
        value: 'MIP',
    },
    {
        key: 8,
        text: CredentialTypeEnum.FCMA,
        value: CredentialTypeEnum.FCMA,
    },
    {
        key: 9,
        text: CredentialTypeEnum.ACMA,
        value: CredentialTypeEnum.ACMA,
    },
];
exports.MembershipDirectoryTypes = [
    { key: 1, text: 'AICPA Regular', value: 'AICPA Regular' },
    { key: 2, text: 'AICPA Affiliate', value: 'AICPA Affiliate' },
    { key: 3, text: 'AICPA Candidate', value: 'AICPA Candidate' },
    { key: 5, text: 'AICPA International Associate', value: 'AICPA International-Associate' },
    { key: 6, text: 'AICPA Student Affiliate', value: 'AICPA Student Affiliate' },
    { key: 7, text: 'CIMA Member', value: 'CIMA Regular' },
    { key: 8, text: 'CIMA Candidate', value: 'CIMA Candidate' },
    { key: 9, text: 'CIMA Affiliate', value: 'CIMA Affiliate' },
    { key: 10, text: 'CIMA Retired', value: 'CIMA Retired' },
];
exports.MembershipTypes = [
    { key: 1, text: 'Regular', value: 'Regular' },
    { key: 2, text: 'Affiliate', value: 'Affiliate' },
    { key: 3, text: 'Candidate', value: 'Candidate' },
    { key: 4, text: 'Pre-Candidate', value: 'Pre-Candidate' },
    { key: 5, text: 'International Associate', value: 'International Associate' },
    { key: 6, text: 'CIMA Candidate', value: 'CIMA Candidate' },
    { key: 7, text: 'CIMA Affiliate', value: 'CIMA Affiliate' },
    { key: 8, text: 'CIMA Regular', value: 'CIMA Regular' },
    { key: 9, text: 'CIMA Retired', value: 'CIMA Retired' },
];
var ExpertiseAreaEnum;
(function (ExpertiseAreaEnum) {
    ExpertiseAreaEnum["ACCOUNTING_AND_FINANCIAL_REPORTING"] = "Accounting and Financial Reporting";
    ExpertiseAreaEnum["STAFF"] = "Staff";
})(ExpertiseAreaEnum = exports.ExpertiseAreaEnum || (exports.ExpertiseAreaEnum = {}));
exports.ExpertiseArea = [
    { key: 1, text: 'All Areas of Expertise', value: 'All Areas of Expertise' },
    { key: 2, text: 'Accounting and Financial Reporting', value: 'Accounting and Financial Reporting' },
    {
        key: 3,
        text: 'Accounting and Financial Reporting - Accounting Compliance and Reporting (IFRS)',
        value: 'Accounting Compliance and Reporting (IFRS)',
    },
    {
        key: 4,
        text: 'Accounting and Financial Reporting - Accounting Compliance and Reporting (Private Companies)',
        value: 'Accounting Compliance and Reporting (Private Companies)',
    },
    {
        key: 5,
        text: 'Accounting and Financial Reporting - Accounting Compliance and Reporting (US)',
        value: 'Accounting Compliance and Reporting (US)',
    },
    {
        key: 6,
        text: 'Accounting and Financial Reporting - Financial Instruments',
        value: 'Financial Instruments',
    },
    {
        key: 7,
        text: 'Accounting and Financial Reporting - Integrated Reporting',
        value: 'Integrated Reporting',
    },
    {
        key: 8,
        text: 'Accounting and Financial Reporting - Internal Control over Financial Reporting',
        value: 'Internal Control over Financial Reporting',
    },
    {
        key: 9,
        text: 'Accounting and Financial Reporting - SEC Regulatory Compliance and Reporting',
        value: 'SEC Regulatory Compliance and Reporting',
    },
    {
        key: 10,
        text: 'Accounting and Financial Reporting - Sustainability',
        value: 'Sustainability',
    },
    { key: 11, text: 'Accounting and Financial Reporting - XBRL', value: 'XBRL' },
    { key: 12, text: 'Advisory/Consulting', value: 'Advisory/Consulting' },
    {
        key: 13,
        text: 'Advisory/Consulting - Performing an Advisory Engagement (planning, performance, reporting, QC)',
        value: 'Performing an Advisory Engagement (planning, performance, reporting, QC)',
    },
    {
        key: 14,
        text: 'Assurance (audit and attest for non-public entities specifically)',
        value: 'Assurance (audit and attest for non-public entities specifically)',
    },
    {
        key: 15,
        text: 'Assurance (audit and attest for non-public entities specifically) - Performing an Attest Engagement (planning, fieldwork, reporting, QC)',
        value: 'Performing an Attest Engagement (planning, fieldwork, reporting, QC)',
    },
    {
        key: 16,
        text: 'Assurance (audit and attest for non-public entities specifically) - Performing an Audit (planning, fieldwork, reporting, QC)',
        value: 'Performing an Audit (planning, fieldwork, reporting, QC)',
    },
    { key: 17, text: 'Compilation and Review', value: 'Compilation and Review' },
    {
        key: 18,
        text: 'Compilation and Review - Performing a Review (planning, performance, reporting, QC)',
        value: 'Performing a Review (planning, performance, reporting, QC)',
    },
    { key: 19, text: 'Corporate Governance', value: 'Corporate Governance' },
    { key: 20, text: 'Corporate Governance - Audit Committee', value: 'Audit Committee' },
    { key: 21, text: 'Employee Benefit Plans', value: 'Employee Benefit Plans' },
    {
        key: 22,
        text: 'Employee Benefit Plans - 401(k) Defined Contribution Plans',
        value: '401(k) Defined Contribution Plans',
    },
    {
        key: 23,
        text: 'Employee Benefit Plans - 403(b) Defined Contribution Plans',
        value: '403(b) Defined Contribution Plans',
    },
    {
        key: 24,
        text: 'Employee Benefit Plans - Auditory Independence (DOL, AICPA, SEC)',
        value: 'Auditory Independence (DOL, AICPA, SEC)',
    },
    {
        key: 25,
        text: 'Employee Benefit Plans - Defined Benefit Plans',
        value: 'Defined Benefit Plans',
    },
    { key: 26, text: 'Employee Benefit Plans - EBP Fraud', value: 'EBP Fraud' },
    {
        key: 27,
        text: 'Employee Benefit Plans - EBP Internal Controls (including Service Organization Control (SOC) 1 reports)',
        value: 'EBP Internal Controls (including Service Organization Control (SOC) 1 reports)',
    },
    {
        key: 28,
        text: 'Employee Benefit Plans - EBP Plan Investments and Fair Value',
        value: 'EBP Plan Investments and Fair Value',
    },
    {
        key: 29,
        text: 'Employee Benefit Plans - Employee Stock Ownership Plans (ESOPs)',
        value: 'Employee Stock Ownership Plans (ESOPs)',
    },
    {
        key: 30,
        text: 'Employee Benefit Plans - ERISA Plan Financial Statement Audits (including Limited Scope Audits)',
        value: 'ERISA Plan Financial Statement Audits (including Limited Scope Audits)',
    },
    {
        key: 31,
        text: 'Employee Benefit Plans - ERISA, DOL and IRS Regulations for EBPs (including Plan Design and IRS Qualification Rules and Test)',
        value: 'ERISA, DOL and IRS Regulations for EBPs (including Plan Design and IRS Qualification Rules and Test)',
    },
    {
        key: 32,
        text: 'Employee Benefit Plans - Form 11-k Plan (SEC) Filers',
        value: 'Form 11-k Plan (SEC) Filers',
    },
    {
        key: 33,
        text: 'Employee Benefit Plans - Form 5500 Reporting',
        value: 'Form 5500 Reporting',
    },
    {
        key: 34,
        text: 'Employee Benefit Plans - Health and Welfare Plans',
        value: 'Health and Welfare Plans',
    },
    {
        key: 35,
        text: 'Employee Benefit Plans - Multiemployer plans',
        value: 'Multiemployer plans',
    },
    {
        key: 36,
        text: 'Employee Benefit Plans - Parties-in-Interest/Prohibited Transactions',
        value: 'Parties-in-Interest/Prohibited Transactions',
    },
    {
        key: 37,
        text: 'Employee Benefit Plans - Payroll Audits (Related to Multiemployer Plans)',
        value: 'Payroll Audits (Related to Multiemployer Plans)',
    },
    { key: 38, text: 'Ethics', value: 'Ethics' },
    { key: 39, text: 'Firm Practice Management', value: 'Firm Practice Management' },
    {
        key: 40,
        text: 'Firm Practice Management - Financial and Admin Operations',
        value: 'Financial and Admin Operations',
    },
    { key: 41, text: 'Firm Practice Management - Human Capital', value: 'Human Capital' },
    { key: 42, text: 'Firm Practice Management - Marketing', value: 'Marketing' },
    {
        key: 43,
        text: 'Firm Practice Management - Practice Growth and Client Service',
        value: 'Practice Growth and Client Service',
    },
    {
        key: 44,
        text: 'Firm Practice Management - Strategy and Planning',
        value: 'Strategy and Planning',
    },
    {
        key: 45,
        text: 'Firm Practice Management - Succession Planning',
        value: 'Succession Planning',
    },
    { key: 46, text: 'Forensic and Valuation Services', value: 'Forensic and Valuation Services' },
    {
        key: 47,
        text: 'Forensic and Valuation Services - Bankruptcy & Reorganization',
        value: 'Bankruptcy & Reorganization',
    },
    {
        key: 48,
        text: 'Forensic and Valuation Services - Business Economic Damages',
        value: 'Business Economic Damages',
    },
    {
        key: 49,
        text: 'Forensic and Valuation Services - Electronic Data Analysis',
        value: 'Electronic Data Analysis',
    },
    {
        key: 50,
        text: 'Forensic and Valuation Services - Employee Stock Ownership Plans (ESOPs)',
        value: 'Employee Stock Ownership Plans (ESOPs)',
    },
    {
        key: 51,
        text: 'Forensic and Valuation Services - Engagement Planning & Preparation and Information Gathering & Preservation',
        value: 'Engagement Planning & Preparation and Information Gathering & Preservation',
    },
    {
        key: 52,
        text: 'Forensic and Valuation Services - Expert Witness Testimony',
        value: 'Expert Witness Testimony',
    },
    {
        key: 53,
        text: 'Forensic and Valuation Services - Fair Value for Financial Reporting',
        value: 'Fair Value for Financial Reporting',
    },
    {
        key: 54,
        text: 'Forensic and Valuation Services - Family Law & Divorce',
        value: 'Family Law & Divorce',
    },
    {
        key: 55,
        text: 'Forensic and Valuation Services - Financial Instruments',
        value: 'Financial Instruments',
    },
    {
        key: 56,
        text: 'Forensic and Valuation Services - Financial Statement Misrepresentation',
        value: 'Financial Statement Misrepresentation',
    },
    {
        key: 57,
        text: 'Forensic and Valuation Services - Fraud Prevention, Detection & Response',
        value: 'Fraud Prevention, Detection & Response',
    },
    {
        key: 58,
        text: 'Forensic and Valuation Services  - Gift & Estate Income Tax, FLPs & LLPs',
        value: 'Gift & Estate Income Tax, FLPs & LLPs',
    },
    {
        key: 59,
        text: 'Forensic and Valuation Services  - Individual Damages',
        value: 'Individual Damages',
    },
    {
        key: 60,
        text: 'Forensic and Valuation Services - Intellectual Property Valuation & Infringement',
        value: 'Intellectual Property Valuation & Infringement',
    },
    {
        key: 61,
        text: 'Forensic and Valuation Services  - M&A Due Diligence & Stakeholder Dispute Resolution',
        value: 'M&A Due Diligence & Stakeholder Dispute Resolution',
    },
    {
        key: 62,
        text: 'Forensic and Valuation Services - Practice Management',
        value: 'Practice Management',
    },
    {
        key: 63,
        text: 'Forensic and Valuation Services  - Report Preparation',
        value: 'Report Preparation',
    },
    {
        key: 64,
        text: 'Forensic and Valuation Services  - Valuation Methods, Approaches, and Analysis',
        value: 'Valuation Methods, Approaches, and Analysis',
    },
    { key: 65, text: 'Governmental', value: 'Governmental' },
    {
        key: 66,
        text: 'Governmental - Accounting Compliance and Reporting under GASB',
        value: 'Accounting Compliance and Reporting under GASB',
    },
    {
        key: 67,
        text: 'Governmental - Auditory Involvement with Municipal Securities Filings',
        value: 'Auditory Involvement with Municipal Securities Filings',
    },
    {
        key: 68,
        text: 'Governmental - Circular A-133 Audit Considerations',
        value: 'Circular A-133 Audit Considerations',
    },
    { key: 69, text: 'Governmental - Compliance Audits', value: 'Compliance Audits' },
    {
        key: 70,
        text: 'Governmental - Government Auditing Standards',
        value: 'Government Auditing Standards',
    },
    {
        key: 71,
        text: 'Governmental - Governmental Financial Statement Audit Considerations',
        value: 'Governmental Financial Statement Audit Considerations',
    },
    { key: 72, text: 'Governmental - HUD Audits (for-profits)', value: 'HUD Audits (for-profits)' },
    {
        key: 73,
        text: 'Governmental - Internal Control over Compliance',
        value: 'Internal Control over Compliance',
    },
    {
        key: 74,
        text: 'Governmental - Internal Control over Financial Reporting',
        value: 'Internal Control over Financial Reporting',
    },
    {
        key: 75,
        text: 'Governmental - Special-Purpose Framework Considerations',
        value: 'Special-Purpose Framework Considerations',
    },
    { key: 76, text: 'Industry', value: 'Industry' },
    {
        key: 77,
        text: 'Industry - Agriculture, Forestry, Fishing and Hunting',
        value: 'Agriculture, Forestry, Fishing and Hunting',
    },
    {
        key: 78,
        text: 'Industry - Arts, Entertainment and Recreation (including Gaming)',
        value: 'Arts, Entertainment and Recreation (including Gaming)',
    },
    { key: 79, text: 'Industry - Auto Dealerships', value: 'Auto Dealerships' },
    { key: 80, text: 'Industry - Brokers/Dealers', value: 'Brokers/Dealers' },
    { key: 81, text: 'Industry - Construction', value: 'Construction' },
    {
        key: 82,
        text: 'Industry - Depository and Lending Institutions',
        value: 'Depository and Lending Institutions',
    },
    {
        key: 83,
        text: 'Industry - Government and Public Sector',
        value: 'Government and Public Sector',
    },
    {
        key: 84,
        text: 'Industry - Health Care and Social Assistance',
        value: 'Health Care and Social Assistance',
    },
    {
        key: 85,
        text: 'Industry - Insurance Life & Health',
        value: 'Insurance Life & Health',
    },
    {
        key: 86,
        text: 'Industry - Insurance Property & Liability',
        value: 'Insurance Property & Liability',
    },
    {
        key: 87,
        text: 'Industry - Investment Companies',
        value: 'Investment Companies',
    },
    {
        key: 88,
        text: 'Industry - Manufacturing',
        value: 'Manufacturing',
    },
    {
        key: 89,
        text: 'Industry - Media Communications and Information',
        value: 'Media Communications and Information',
    },
    {
        key: 90,
        text: 'Industry - Mining, Quarrying, and Oil and Gas Extraction',
        value: 'Mining, Quarrying, and Oil and Gas Extraction',
    },
    {
        key: 91,
        text: 'Industry - Not-for-Profit',
        value: 'Not-for-Profit',
    },
    {
        key: 92,
        text: 'Industry - Professional, Scientific and Technical Services (including Business Services)',
        value: 'Professional, Scientific and Technical Services (including Business Services)',
    },
    {
        key: 93,
        text: 'Industry - Real Estate and Rental and Leasing',
        value: 'Real Estate and Rental and Leasing',
    },
    {
        key: 94,
        text: 'Industry - Transportation and Warehousing',
        value: 'Transportation and Warehousing',
    },
    {
        key: 95,
        text: 'Industry - Utilities',
        value: 'Utilities',
    },
    {
        key: 96,
        text: 'Industry - Wholesale and Retail Trade',
        value: 'Wholesale and Retail Trade',
    },
    {
        key: 97,
        text: 'Information Management and Technology Assurance',
        value: 'Information Management and Technology Assurance',
    },
    {
        key: 98,
        text: 'Information Management and Technology Assurance - Business Intelligence',
        value: 'Business Intelligence',
    },
    {
        key: 99,
        text: 'Information Management and Technology Assurance - Cloud Computing',
        value: 'Cloud Computing',
    },
    {
        key: 100,
        text: 'Information Management and Technology Assurance - Computer Fraud',
        value: 'Computer Fraud',
    },
    {
        key: 101,
        text: 'Information Management and Technology Assurance - Cybersecurity',
        value: 'Cybersecurity',
    },
    {
        key: 102,
        text: 'Information Management and Technology Assurance - Information Management',
        value: 'Information Management',
    },
    {
        key: 103,
        text: 'Information Management and Technology Assurance - IT & Integrated Audits',
        value: 'IT & Integrated Audits',
    },
    {
        key: 104,
        text: 'Information Management and Technology Assurance - IT Risk Management and Internal Controls',
        value: 'IT Risk Management and Internal Controls',
    },
    {
        key: 105,
        text: 'Information Management and Technology Assurance - Service Organization Controls',
        value: 'Service Organization Controls',
    },
    {
        key: 106,
        text: 'Management Accounting',
        value: 'Management Accounting',
    },
    {
        key: 107,
        text: 'Management Accounting - Accounting Operations Management',
        value: 'Accounting Operations Management',
    },
    {
        key: 108,
        text: 'Management Accounting - Business Acumen, People and Leadership Skills',
        value: 'Business Acumen, People and Leadership Skills',
    },
    {
        key: 109,
        text: 'Management Accounting - Business Planning, Budgeting and Forecasting',
        value: 'Business Planning, Budgeting and Forecasting',
    },
    {
        key: 110,
        text: 'Management Accounting - Corporate Finance and Treasury Management',
        value: 'Corporate Finance and Treasury Management',
    },
    {
        key: 111,
        text: 'Management Accounting - Ethics',
        value: 'Ethics',
    },
    {
        key: 112,
        text: 'Management Accounting - Financial Accounting and Reporting',
        value: 'Financial Accounting and Reporting',
    },
    {
        key: 113,
        text: 'Management Accounting - Human Resource and Talent Management',
        value: 'Human Resource and Talent Management',
    },
    {
        key: 114,
        text: 'Management Accounting - Information Systems and Management',
        value: 'Information Systems and Management',
    },
    {
        key: 115,
        text: 'Management Accounting - International Business',
        value: 'International Business',
    },
    {
        key: 116,
        text: 'Management Accounting - Mergers and Acquisitions',
        value: 'Mergers and Acquisitions',
    },
    {
        key: 117,
        text: 'Management Accounting - Performance and Cost Management, Analysis and Control',
        value: 'Performance and Cost Management, Analysis and Control',
    },
    {
        key: 118,
        text: 'Management Accounting - Risk Management and Internal Control',
        value: 'Risk Management and Internal Control',
    },
    {
        key: 119,
        text: 'Management Accounting - Strategy and Governance',
        value: 'Strategy and Governance',
    },
    {
        key: 120,
        text: 'Management Accounting - Tax Compliance, Planning and Strategy',
        value: 'Tax Compliance, Planning and Strategy',
    },
    { key: 121, text: 'Other', value: 'Other' },
    {
        key: 122,
        text: 'Other - Accounting Education',
        value: 'Accounting Education',
    },
    {
        key: 123,
        text: 'Other - Legal Services',
        value: 'Legal Services',
    },
    { key: 124, text: 'Peer Review', value: 'Peer Review' },
    {
        key: 125,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment',
        value: 'Tax/Estate/Retirement/Risk Management/Investment',
    },
    {
        key: 126,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Cash Flow Planning',
        value: 'Cash Flow Planning',
    },
    {
        key: 127,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Charitable Planning',
        value: 'Charitable Planning',
    },
    {
        key: 128,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Closely Held Business Planning',
        value: 'Closely Held Business Planning',
    },
    {
        key: 129,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Education Planning',
        value: 'Education Planning',
    },
    {
        key: 130,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Elder Planning',
        value: 'Elder Planning',
    },
    {
        key: 131,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Employee Benefits/Executive Compensation',
        value: 'Employee Benefits/Executive Compensation',
    },
    {
        key: 132,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Estate, Gift and Wealth Transfer Planning',
        value: 'Estate, Gift and Wealth Transfer Planning',
    },
    {
        key: 133,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Fundamental Financial Planning Knowledge & Skills',
        value: 'Fundamental Financial Planning Knowledge & Skills',
    },
    {
        key: 134,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Individual Tax Planning',
        value: 'Individual Tax Planning',
    },
    {
        key: 135,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Insurance Planning/Risk Management Planning',
        value: 'Insurance Planning/Risk Management Planning',
    },
    {
        key: 136,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Integrated Personal Financial Planning',
        value: 'Integrated Personal Financial Planning',
    },
    {
        key: 137,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Investment Planning (without AUM or product sales)',
        value: 'Investment Planning (without AUM or product sales)',
    },
    {
        key: 138,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Retirement Planning',
        value: 'Retirement Planning',
    },
    {
        key: 139,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Significant Event Planning (Marriage, Divorce, Family Additions, Death, etc.)',
        value: 'Significant Event Planning (Marriage, Divorce, Family Additions, Death, etc.)',
    },
    {
        key: 140,
        text: 'Personal Financial Planning - Tax/Estate/Retirement/Risk Management/Investment - Wealth Management/Investment Advisory Services',
        value: 'Wealth Management/Investment Advisory Services',
    },
    { key: 141, text: 'Tax', value: 'Tax' },
    {
        key: 142,
        text: 'Tax - C Corporation Income Taxation',
        value: 'C Corporation Income Taxation',
    },
    {
        key: 143,
        text: 'Tax - Employee Benefits',
        value: 'Employee Benefits',
    },
    {
        key: 144,
        text: 'Tax - Individual Income Taxation',
        value: 'Individual Income Taxation',
    },
    {
        key: 145,
        text: 'Tax - International Tax',
        value: 'International Tax',
    },
    {
        key: 146,
        text: 'Tax - IRS Practice & Procedure',
        value: 'IRS Practice & Procedure',
    },
    {
        key: 147,
        text: 'Tax - Partnership Taxation',
        value: 'Partnership Taxation',
    },
    {
        key: 148,
        text: 'Tax - S Corporation Income Taxation',
        value: 'S Corporation Income Taxation',
    },
    {
        key: 149,
        text: 'Tax - State & Local Tax',
        value: 'State & Local Tax',
    },
    {
        key: 150,
        text: 'Tax - Tax Ethics & Standards',
        value: 'Tax Ethics & Standards',
    },
    {
        key: 151,
        text: 'Tax - Tax Exempt Organizations',
        value: 'Tax Exempt Organizations',
    },
    {
        key: 152,
        text: 'Tax - Tax Practice Management',
        value: 'Tax Practice Management',
    },
    {
        key: 153,
        text: 'Tax - Taxation of Estates and Trusts',
        value: 'Taxation of Estates and Trusts',
    },
    {
        key: 154,
        text: 'Book-keeping/accounting',
        value: 'Book-keeping/accounting',
    },
    {
        key: 155,
        text: 'Business planning/budgeting',
        value: 'Business planning/budgeting',
    },
    {
        key: 156,
        text: 'Business process improvement',
        value: 'Business process improvement',
    },
    {
        key: 157,
        text: 'Business tax planning/advice',
        value: 'Business tax planning/advice',
    },
    {
        key: 158,
        text: 'Cash flow management/treasury',
        value: 'Cash flow management/treasury',
    },
    {
        key: 159,
        text: 'Company secretarial matters',
        value: 'Company secretarial matters',
    },
    {
        key: 160,
        text: 'Contribution/profit analysis',
        value: 'Contribution/profit analysis',
    },
    { key: 161, text: 'Cost reduction', value: 'Cost reduction' },
    {
        key: 162,
        text: 'Costing/accounting systems',
        value: 'Costing/accounting systems',
    },
    { key: 163, text: 'TCSP', value: 'TCSP' },
    {
        key: 164,
        text: 'External financial reporting',
        value: 'External financial reporting',
    },
    {
        key: 165,
        text: 'Funding to businesses',
        value: 'Funding to businesses',
    },
    { key: 166, text: 'Interim management', value: 'Interim management' },
    {
        key: 167,
        text: 'Internal audit/risk analysis',
        value: 'Internal audit/risk analysis',
    },
    {
        key: 168,
        text: 'Management performance reports',
        value: 'Management performance reports',
    },
    {
        key: 169,
        text: 'Payroll/NI/PAYE administration',
        value: 'Payroll/NI/PAYE administration',
    },
    {
        key: 170,
        text: 'Personal tax planning/advice',
        value: 'Personal tax planning/advice',
    },
];
exports.functionalSpecialismList = [
    {
        text: 'Book-keeping/accounting',
        value: 'Book-keeping/accounting',
    },
    {
        text: 'Business planning/budgeting',
        value: 'Business planning/budgeting',
    },
    {
        text: 'Business process improvement',
        value: 'Business process improvement',
    },
    {
        text: 'Business tax planning/advice',
        value: 'Business tax planning/advice',
    },
    {
        text: 'Cash flow management/treasury',
        value: 'Cash flow management/treasury',
    },
    {
        text: 'Company secretarial matters',
        value: 'Company secretarial matters',
    },
    {
        text: 'Contribution/profit analysis',
        value: 'Contribution/profit analysis',
    },
    {
        text: 'Cost reduction',
        value: 'Cost reduction',
    },
    {
        text: 'Costing/accounting systems',
        value: 'Costing/accounting systems',
    },
    {
        text: 'TCSP',
        value: 'TCSP',
    },
    {
        text: 'External financial reporting',
        value: 'External financial reporting',
    },
    {
        text: 'Funding to businesses',
        value: 'Funding to businesses',
    },
    {
        text: 'Interim management',
        value: 'Interim management',
    },
    {
        text: 'Internal audit/risk analysis',
        value: 'Internal audit/risk analysis',
    },
    {
        text: 'Management performance reports',
        value: 'Management performance reports',
    },
    {
        text: 'Payroll/NI/PAYE administration',
        value: 'Payroll/NI/PAYE administration',
    },
    {
        text: 'Personal tax planning/advice',
        value: 'Personal tax planning/advice',
    },
    {
        text: 'Other',
        value: 'Other',
    },
];
exports.MileRadius = [
    {
        key: 1,
        text: '5 miles',
        value: '5',
    },
    {
        key: 2,
        text: '10 miles',
        value: '10',
    },
    {
        key: 3,
        text: '25 miles',
        value: '25',
    },
    {
        key: 4,
        text: '50 miles',
        value: '50',
    },
];
exports.credentialTypeSKUs = {
    PFS: ['CREDPFS01', 'CREDPFS02', 'CREDPFS03', 'CREDPFS04'],
    MIP: ['CIMAMIP01'],
    ACMA: ['CIMAACMA01'],
    CVFI: ['CREDCVFI01', 'CREDCVFI02', 'CREDCVFI03', 'CREDCVFI04', 'CREDCVFI05'],
    ABV: ['CREDABV01', 'CREDABV02', 'CREDABV03'],
    CEIV: ['CREDCEIV01', 'CREDCEIV02', 'CREDCEIV03'],
    CGMA: ['CIMACGMA01', 'CREDCGMADES', 'CREDCGMADES-R'],
    FCMA: ['CIMAFCMA01'],
    CFF: ['CREDCFF01', 'CREDCFF02', 'CREDCFF03', 'CREDCFF04'],
    CITP: ['CREDCITP01', 'CREDCITP02', 'CREDCITP03', 'CREDCITP04'],
};
//# sourceMappingURL=index.js.map